import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar } from "@fortawesome/free-solid-svg-icons";
import logo from "../images/logo.png";

export default function NavbarVTC() {
  const navigate = useNavigate();
  return (
    <Navbar expand="lg" sticky="top" className="navbar-vtc py-3 shadow-lg">
      <Container>
        <Navbar.Brand href="/">
          <img src={logo} alt="AzurPac VTC" className="navbar-logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          {/* wrapper actions */}
          <div className="ms-auto d-flex gap-2 navbar-actions">
            <Button
              variant="outline-light"
              className="nav-link-premium flex-fill"
              onClick={() => navigate("/consultation-reservation")}
            >
              Mes réservations
            </Button>

            <Button
              className="btn-reserver-premium flex-fill"
              onClick={() => navigate("/réserver")}
            >
              <FontAwesomeIcon icon={faCar} className="me-2" />
              Réserver
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
